import img from "../Images/logo.jpeg";

function Header() {
    return (
      <header style={{ backgroundColor: "#003366", color: "#fff", padding: "20px", textAlign: "center" }}>
        <img src={img} alt="Logo" height="60" style={{ verticalAlign: "middle", marginRight: "10px" }} />
        <h1 style={{ display: "inline-block", verticalAlign: "middle", fontSize: "28px" }}>SLD Petroleum Fuel Enterprises</h1>
      </header>
    );
  }
  export default Header;